import React, { useState } from 'react'
 
 
import TobaccoProcessingList from './TobaccoProcessingList';
import TobaccoProcessingForm from './TobaccoProcessingForm';

const TobaccoProcessing= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");


  return (
    <>
      {fromIsShown ? (
          <TobaccoProcessingForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <TobaccoProcessingList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default TobaccoProcessing